module.exports = __webpack_public_path__ + "static/media/qAtmosphereInfo6.52ac48e0.webp";